import { ASADO_BASE_URLS as baseUrls } from '../utils/api';

const getDisclaimerByName = async (name: string, env: 'dev' | 'prod') => {
  try {
    const response = await fetch(`${baseUrls[env]}/public/cms/sanity/disclaimer/${name}`);
    const responseJson = await response.json();
    return responseJson;
  } catch (error: unknown) {
    throw new Error(error as string);
  }
};

export { getDisclaimerByName };
